<template>
  <div v-opacity class="graderesult" :style="{backgroundImage: 'url(' +backgroundImage+ ')'}">
    <div v-if="detail" class="base">
      <van-nav-bar class="isccc mb-16" title="查看结果" left-arrow @click-left="onBack" />
      <div class="container pb-16" :class="{'pb-80': detail.resultType == 1 && detail.hasPass == 1}" style="padding-left: 10px; padding-right: 10px;">
        <!-- resultType (integer, optional): 结果类型 0-普通成绩 1-合格证 2-科目成绩单 , -->
        <!-- showStyle (integer, optional): 展示样式 1-显示名次 2-显示分数 3-分数/名次都显示 4-仅显示是否通过 , -->
        <!-- isUndecidedResult 是否未判定通过的成绩 0-否 1-是 , -->
        <!-- 1. 合格证11-->
        <template v-if="detail.resultType == 1 && detail.hasPass == 1">
          <div id="gradecard" style="background: #fff; padding: 6px; border-radius: 6px;">
            <GradeCard :detail="detail"></GradeCard>
          </div>
          <div class="fixed-btn">
            <van-button @click="onDownload" round block size="large" color="linear-gradient(137deg, #00A7FF 0%, #0076FF 100%)">
              保存
            </van-button>
          </div>
        </template>
        <div v-else class="r-content pl-16 pr-16 pb-16 pt-16">
          <div class="flex jc-center">
            <img class="isnoneimgwait" v-if="Tool.isNull(detail.hasPass)" src="../../static/wait.png" alt="">
            <img class="isnoneimg" v-else-if="detail.hasPass == 1 || detail.isUndecidedResult == 1" src="../../static/img_tgcs.png" alt="">
            <img class="isnoneimg" v-else src="../../static/img_wtgcs.png" alt="">
          </div>
          <div :class="detail.hasPass == 1 ? 'gt-title' : Tool.isNull(detail.hasPass) ? 'gt-title-result' : 'gt-title-fail'">
            <div>
              <div class="content">{{detail.title}}</div>
              <div id="qrcode" ref="qrcode" class="qr-code"></div>
            </div>
          </div>
          <!--<div class="line mb-24 mt-24"></div>-->
          <div :class="detail.hasPass == 1 || Tool.isNull(detail.hasPass) ? 'exam-result-info' : 'exam-result-info-fail'">
            <div class="gt-text">{{detail.examineeName}}同学：</div>
            <div v-html="detail.resultNote" class="mt-8 gt-text mb-8 ti2" style="white-space: pre-wrap;"></div>
            <div class="flex gt-text jc-end tr">{{detail.collegeName}}</div>
            <div class="flex gt-text jc-end" v-if="detail.resultPublishDesc">{{ detail.resultPublishDesc }}</div>
          </div>
          <!-- <div class="flex gt-text jc-end" style="color: #7D7E82;">{{detail.publishTime}}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar, Icon, Button } from 'vant'
import * as _localStorage from '@/utils/storage'
import html2canvas from 'html2canvas'
import GradeCard from './components/grade-card'
import dayjs from 'dayjs';
import QRCode from 'qrcodejs2'
import Tool from '@/utils/tools'

export default {
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Icon.name]: Icon,
    GradeCard,
  },
  name: 'result',
  data() {
    return {
      Tool,
      dayjs,
      info: '',
      backgroundImage: require('../../static/bg_ty_sj_new.jpg'),
      detail: null,
    }
  },
  mounted() {
    // this.setQrcode()
    if(!(this.detail.resultType == 1 && this.detail.hasPass == 1)){
      this.setQrcode()
    }
  },
  async created() {
    this.detail = _localStorage.getStorageSync('grade')
    this.detail.resultNote = this.detail.resultNote.replace(/\n/g, '<br>')
    this.info = _localStorage.getStorageSync('info')
    if (this.info.mobileWallpaperUrl) {
      this.backgroundImage = this.info.mobileWallpaperUrl
    }
    this.formatText()
  },
  methods: {
    setQrcode(){
      let qrcodeObj = this.$refs.qrcode;
      new QRCode(qrcodeObj, {
        text: this.detail.qrCode,
      })
    },
    onBack() {
      this.$router.back()
    },
    formatText() {
      if (this.detail.isUndecidedResult == 1) {
        this.detail.title = '考试结果'
        this.detail.message = `你的考试分数如下：${this.detail.specialtyName}: ${this.detail.scoreText}分`
      } else {
        if (this.detail.hasPass == 1) {
          this.detail.title = '恭喜你通过考试'
          this.detail.message = `恭喜你成绩合格，通过我校${this.detail.specialtyName}专业考试。`
        } else {
          this.detail.title = '你未通过考试'
          this.detail.message = `很遗憾你的成绩不合格，未通过我校${this.detail.specialtyName}专业考试。`
        }
      }
    },
    async convertToImage(container, options = {}) {
      // 生成快照
      // 设置放大倍数
      const scale = window.devicePixelRatio > 2 ? window.devicePixelRatio : 2
      // 传入节点原始宽高
      const width = container.offsetWidth
      const height = container.offsetHeight
      // html2canvas配置项
      const ops = {
        scale,
        width,
        height,
        useCORS: true,
        allowTaint: false,
        ...options,
      }
      return html2canvas(container, ops).then((canvas) => {
        // 返回图片的二进制数据
        return canvas.toDataURL('image/png')
      })
      // 调用函数，取到截图的二进制数据，对图片进行处理（保存本地、展示等）
      // const imgBlobData = await convertToImage(element)
    },
    dataURLToBlob(dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = window.atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    async onDownload() {
      const element = document.querySelector('#gradecard')
      let a = document.createElement('a')
      const imgBlobData = await this.convertToImage(element)
      a.style.display = 'none'
      const blob = window.URL.createObjectURL(this.dataURLToBlob(imgBlobData))
      a.setAttribute('href', blob)
      a.setAttribute('download', '合格证.png')
      document.body.appendChild(a)
      a.click()
      setTimeout(()=>{
        window.URL.revokeObjectURL(blob)
        document.body.removeChild(a)
      },200)
    },
  },
}
</script>

<style lang="less" scoped>
.ti2{
  text-indent: 2em;
}
.graderesult {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-size: cover;
  background-color: rgba(0, 0, 0, 0.3);
  background-repeat: no-repeat;
  background-position: center;
}
.base {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  z-index: 1;
}
.container {
  width: 100%;
  min-height: calc(100vh - 46px);
  overflow: auto;
}
.r-content {
  width: 100%;
  min-height: 100%;
  background: #fff;
  box-shadow: 0px 8px 16px rgba(39, 3, 27, 0.24);
  border-radius: 8px;

  .exam-result-info {
    padding: 8px;
    border-radius: 8px;
    border: 1px solid #0CD0A2;
  }

  .exam-result-info-fail {
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #FF6262;
  }

  .gt-title{
    position: relative;
    border-radius: 8px;
    border: 1px solid #0CD0A2;
    height: 100px;
    //background: rgba(12,208,162,0.06);
    background: rgba(12,208,162,0.06) url("../../static/pass.png") no-repeat;
    background-size: 60% 60%;
    border-bottom: 0;
    padding: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
  }

  .gt-title-fail{
    position: relative;
    border-radius: 8px;
    height: 100px;
    padding: 8px;
    border: 1px solid #FF6262;
    background: rgba(255,98,98,0.04) url("../../static/fail.png") no-repeat;
    background-size: 60% 60%;
    border-bottom: 0;
  }

  .gt-title-result{
    position: relative;
    border-radius: 8px;
    height: 100px;
    padding: 8px;
    border: 1px solid #0CD0A2;
    background: rgba(12,208,162,0.06) url("../../static/result.png") no-repeat;
    background-size: 60% 60%;
    border-bottom: 0;
  }

  .content{
    text-align: left;
    margin-top: 12px;
    margin-left: 0px;
  }

  .qr-code{
    position: absolute;
    width: 84px;
    height: 84px;
    right: 8px;
    top: 8px;
    //border: 1px solid #aa403b;
    z-index: 9;
    /deep/ img{
      width: 84px!important;
      height: 84px!important;
    }
    /deep/ canvas{
      width: 84px!important;
      height: 84px!important;
    }
  }

}

.isccc /deep/ .van-icon {
  color: #323233;
}
.grade {
  width: 640px;
  // height: 592px;
  background: #f8f8f8;
  border-radius: 4px;
  padding: 32px;
}
.gt-title {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  line-height: 35px;
  color: #666666;
  text-align: center;
}
.gt-text {
  word-break: break-all;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 26px;
  color: #001236;
}
.isnoneimg {
  width: 245px;
  height: 170px;
  /* margin-bottom: 30px/2; */
}
.isnoneimgwait {
  width: 245px;
  height: 150px;
  margin-bottom: 8px;
  /* margin-bottom: 30px/2; */
}
.fixed-btn {
  position: fixed;
  width: calc(100vw - 32px);
  bottom: 22px;
  left: 16px;
  z-index: 1000;
}
</style>